import Vue from 'vue'
import router from './router'
import iView, { Modal } from 'iview';
import plugins from './components/plugins'
import { http, post } from './api/http'
import 'iview/dist/styles/iview.css';
import App from './App'
import Clipboard from 'v-clipboard'
// 引入i18n国际化插件
import VueI18n from 'vue-i18n'
import VueSidebarMenu from 'vue-sidebar-menu'

Vue.config.productionTip = false

Vue.use(iView);
Vue.use(plugins);
Vue.use(Clipboard)
Vue.use(VueI18n);
Vue.use(VueSidebarMenu)
    // 注册i18n实例并引入语言文件
const i18n = new VueI18n({
    locale: localStorage.getItem("locale") || 'en', // 定义默认语言为中文
    messages: {
        'zh': require('@/assets/languages/zh.json'),
        'en': require('@/assets/languages/en.json')
    }
})
Vue.prototype.$Message.config({
    top: 300,
    duration: 2
});
Vue.prototype.$post = post;
Vue.prototype.$http = http
router.beforeEach((to, from, next) => {
    console.log(to, from, "======================location=========================");
    document.title = localStorage.getItem('shopName');
    // Vue.prototype.$message.config({
    //   type: "error",
    //   message: "身份已过期，请重新登录"
    // });
    if (localStorage.getItem('token') || to.path === "/login" || to.path === "/register" || to.path === "/noviceguidance") {
        next()
    } else {
        next({
            path: "/login"
        })
    }
})


// 系统
const ua = navigator.userAgent.toLowerCase();
const testUa = regexp => regexp.test(ua);
let system = "unknown";
if (testUa(/windows|win32|win64|wow32|wow64/ig)) {
    system = "windows"; // window系统

} else if (testUa(/macintosh|macintel/ig)) {
    system = "osx"; // osx系统
} else if (testUa(/x11/ig)) {
    system = "linux"; // linux系统
} else if (testUa(/android|adr/ig)) {
    system = "android"; // android系统
    window.location.href = 'http://phone.haohong56.com/#/load'
} else if (testUa(/ios|iphone|ipad|ipod|iwatch/ig)) {
    system = "ios"; // ios系统
    window.location.href = 'http://phone.haohong56.com/#/load'
}

new Vue({
    el: '#app',
    router,
    i18n,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js